import clsx from 'clsx';
import {
  getBgColorFromColorStrength,
  getTextColorFromColorStrength,
  GradientDropdownStrength,
} from './dropdown/GradientDropdown';

export function GradientTag({
  strength,
  name,
  percentage,
}: {
  strength: GradientDropdownStrength;
  name: string;
  percentage?: number;
}) {
  return (
    <div
      className={clsx(
        'flex truncate rounded-md p-1 font-bold w-full gap-3 justify-between',
        getBgColorFromColorStrength(strength),
        getTextColorFromColorStrength(strength),
      )}
    >
      {name}
      {percentage !== undefined && (
        <span className="text-xs text-gray-300">
          ({Math.round(percentage)}%)
        </span>
      )}
    </div>
  );
}
